import { once } from "node:events";
import type { Readable, Writable } from "node:stream";

export async function readStdin(stream: Readable) {
  const chunks: Buffer[] = [];
  stream.on("data", (chunk) => {
    chunks.push(Buffer.isBuffer(chunk) ? chunk : Buffer.from(String(chunk)));
  });
  await once(stream, "end");
  return Buffer.concat(chunks).toString("utf8");
}

export async function writeJson(
  stream: Writable,
  value: unknown,
  options: { pretty: boolean },
) {
  const payload = JSON.stringify(value, null, options.pretty ? 2 : 0);
  await new Promise<void>((resolve, reject) => {
    stream.write(`${payload}\n`, (error) => {
      if (error == null) {
        resolve();
        return;
      }
      reject(error);
    });
  });
}

export async function writeText(stream: Writable, value: string) {
  await new Promise<void>((resolve, reject) => {
    stream.write(`${value}\n`, (error) => {
      if (error == null) {
        resolve();
        return;
      }
      reject(error);
    });
  });
}
